import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

interface HeatmapData {
  topic: string;
  value: number;
  color: string;
}

const RedditHeatmap: React.FC = () => {
  const [data, setData] = useState<HeatmapData[]>([]);

  const baseTopics = [
    { topic: '科技', baseValue: 95, color: '#3b82f6' },
    { topic: '游戏', baseValue: 88, color: '#ef4444' },
    { topic: '新闻', baseValue: 82, color: '#f97316' },
    { topic: '科学', baseValue: 75, color: '#22c55e' },
    { topic: '娱乐', baseValue: 68, color: '#8b5cf6' },
    { topic: '体育', baseValue: 60, color: '#ec4899' },
  ];

  const generateRandomData = (): HeatmapData[] => {
    return baseTopics.map(topic => {
      const randomChange = (Math.random() - 0.5) * 20;
      const newValue = Math.max(10, Math.min(100, topic.baseValue + randomChange));
      return {
        ...topic,
        value: Math.round(newValue),
      };
    }).sort((a, b) => b.value - a.value);
  };

  useEffect(() => {
    setData(generateRandomData());
    const interval = setInterval(() => {
      setData(generateRandomData());
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full h-80">
      <ResponsiveContainer>
        <BarChart data={data} layout="vertical" margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
          <XAxis type="number" hide />
          <YAxis type="category" dataKey="topic" tickLine={false} axisLine={false} tick={{ fill: '#6b7280', fontSize: 14 }} width={60} />
          <Tooltip
            cursor={{ fill: 'rgba(243, 244, 246, 0.5)' }}
            contentStyle={{
              background: 'rgba(255, 255, 255, 0.8)',
              border: '1px solid #e5e7eb',
              borderRadius: '0.5rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            }}
          />
          <Bar dataKey="value" barSize={20} radius={[0, 10, 10, 0]}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RedditHeatmap;